import { memo } from 'react';

import { cn } from '../../lib/styles';

interface ButtonGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

const IconButtonGroupBase = ({ children, className, ...rest }: ButtonGroupProps) => {
  return (
    <div
      className={cn(
        'inline-flex items-center bg-bg-sur-primary gap-1 p-1 shadow-xsm rounded-xl border border-solid border-border-default',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export const IconButtonGroup = memo(IconButtonGroupBase);
